<h1 class="pb-2">Sign Up</h1>
<form [formGroup]="billingForm">
  <p class="billing-section-label">Account</p>
  <div class="row">
    <div class="form-group col-12 col-sm-6">
      <label class="sr-only" for="billingFirstName">First Name</label>
      <input type="text" class="form-control" id="billingFirstName" placeholder="First Name"
        formControlName="firstName" autocomplete="given-name" required
        [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('firstName'), 'required')}">
      @if (formService.controlHasError(billingForm.get('firstName'), 'required')) {
        <div class="form-control-feedback">First Name is required</div>
      }
    </div>
    <div class="form-group col-12 col-sm-6">
      <label class="sr-only" for="billingLastName">Last Name</label>
      <input type="text" class="form-control" id="billingLastName" placeholder="Last Name"
        formControlName="lastName" autocomplete="family-name" required
        [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('lastName'), 'required')}">
      @if (formService.controlHasError(billingForm.get('lastName'), 'required')) {
        <div class="form-control-feedback">Last Name is required</div>
      }
    </div>
  </div>
  <div class="form-group">
    <label class="sr-only" for="billingEmail">Email</label>
    <input type="email" class="form-control" id="billingEmail" placeholder="Email"
      formControlName="email" autocomplete="email" required
      [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('email'))}">
    @if (formService.controlHasError(billingForm.get('email'), 'required')) {
      <div class="form-control-feedback">Email is required</div>
    }
    @if (formService.controlHasError(billingForm.get('email'), 'email')) {
      <div class="form-control-feedback">Not valid email</div>
    }
  </div>
  <div class="form-group">
    <label class="sr-only" for="billingPhoneNumber">Phone Number</label>
    <app-phone-input
      inputId="billingPhoneNumber"
      formControlName="phoneNumber">
    </app-phone-input>
    @if (formService.controlHasError(billingForm.get('phoneNumber'), 'required')) {
      <div class="form-control-feedback">Phone number is required</div>
    }
    @if (formService.controlHasError(billingForm.get('phoneNumber'), 'phoneNumber')) {
      <div class="form-control-feedback">Enter a valid phone number</div>
    }
  </div>
  <div class="form-group">
    <label class="sr-only" for="billingPassword">Password</label>
    <input type="password" class="form-control" id="billingPassword" placeholder="Password"
      formControlName="password" autocomplete="new-password" required
      [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('password'), 'required')}">
    @if (formService.controlHasError(billingForm.get('password'), 'required')) {
      <div class="form-control-feedback">Password is required</div>
    }
  </div>

  <p class="billing-section-label">Payment</p>
  <div class="form-group">
    <label for="billingCardNumber">Card Number</label>
    <div class="form-control stripe-field" id="billingCardNumber" #cardNumber></div>
  </div>
  <div class="row">
    <div class="form-group col-7">
      <label for="billingCardExpiry">Expiration Date</label>
      <div class="form-control stripe-field" id="billingCardExpiry" #cardExpiry></div>
    </div>
    <div class="form-group col-5">
      <label for="billingCardCvc">CVV</label>
      <div class="form-control stripe-field" id="billingCardCvc" #cardCvc></div>
    </div>
  </div>
  <div class="form-group">
    <label for="billingNameOnCard">Name on Card</label>
    <input type="text" class="form-control" id="billingNameOnCard" placeholder="Name on Card"
      formControlName="nameOnCard" autocomplete="cc-name" maxlength="100" required
      [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('nameOnCard'))}">
    @if (formService.controlHasError(billingForm.get('nameOnCard'), 'required')) {
      <div class="form-control-feedback">Name on card is required</div>
    }
  </div>

  <!-- <p class="billing-section-label">Billing Address</p>
  <div class="form-group">
    <label class="sr-only" for="billingAddressLine1">Address Line 1</label>
    <input type="text" class="form-control" id="billingAddressLine1" placeholder="Address Line 1"
      formControlName="addressLine1" autocomplete="billing address-line1" required
      [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('addressLine1'))}">
    @if (formService.controlHasError(billingForm.get('addressLine1'), 'required')) {
      <div class="form-control-feedback">Billing address is required</div>
    }
  </div>
  <div class="form-group">
    <label class="sr-only" for="billingAddressLine2">Address Line 2</label>
    <input type="text" class="form-control" id="billingAddressLine2" placeholder="Address Line 2 (optional)"
      formControlName="addressLine2" autocomplete="billing address-line2">
  </div>
  <div class="row">
    <div class="form-group col-12 col-sm-6">
      <label class="sr-only" for="billingCity">City</label>
      <input type="text" class="form-control" id="billingCity" placeholder="City"
        formControlName="city" autocomplete="billing address-level2" required
        [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('city'))}">
      @if (formService.controlHasError(billingForm.get('city'), 'required')) {
        <div class="form-control-feedback">City is required</div>
      }
    </div>
    <div class="form-group col-12 col-sm-6">
      <label class="sr-only" for="billingState">State / Province</label>
      <input type="text" class="form-control" id="billingState" placeholder="State / Province"
        formControlName="state" autocomplete="billing address-level1">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-12 col-sm-6">
      <label class="sr-only" for="billingPostalCode">Postal Code</label>
      <input type="text" class="form-control" id="billingPostalCode" placeholder="Postal Code"
        formControlName="postalCode" autocomplete="billing postal-code" required
        [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('postalCode'))}">
      @if (formService.controlHasError(billingForm.get('postalCode'), 'required')) {
        <div class="form-control-feedback">Postal code is required</div>
      }
    </div>
    <div class="form-group col-12 col-sm-6">
      <label class="sr-only" for="billingCountry">Country Code</label>
      <input type="text" class="form-control" id="billingCountry" placeholder="Country Code (US)"
        formControlName="country" autocomplete="billing country" maxlength="2" required
        [ngClass]="{'is-invalid' : formService.controlHasError(billingForm.get('country'))}"> -->
      <!-- @if (formService.controlHasError(billingForm.get('country'), 'required')) {
        <div class="form-control-feedback">Country code is required</div>
      } -->
      <!-- @if (formService.controlHasError(billingForm.get('country'), 'pattern')) {
        <div class="form-control-feedback">Enter a two-letter country code, such as US</div>
      } -->
    <!-- </div>
  </div> -->

  @if (stripeFormError) {
    <div class="stripe-error mb-3" role="alert">{{ stripeFormError }}</div>
  }

  <button type="button" class="btn btn-block btn-primary"
    [disabled]="!stripeReady || isSubmitting || signupComplete"
    (click)="submitForm()">
    @if (isSubmitting) {
      Creating Account...
    } @else if (signupComplete) {
      Account Created
    } @else {
      Sign Up
    }
  </button>
</form>

<app-feedback></app-feedback>
